import React from "react"

/**
 * RequiredInfoBanner shows for admin users when account needs required info.
 *
 * IF THIS COMPONENT IS UPDATED, UPDATE THE RAILS PARTIAL AT app/views/layouts/_required_info_needed.html.erb
 *
 * @param {string} requiredInfoDetails - The details of the required info
 */
export function RequiredInfoBanner({ requiredInfoDetails }) {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href=""
      className="alert alert--banner alert--admin"
      data-toggle="modal"
      data-target="#requiredInfoModal"
    >
      <span className="label">admin</span>
      This account still needs to {requiredInfoDetails} before sending can be
      enabled.
    </a>
  )
}
